import React from "react";
import { HStack, Text, Icon } from "@chakra-ui/react";
import { FiChevronRight } from "react-icons/fi";

const Breadcrumb = ({
  items = [],
  onItemClick,
  separator = FiChevronRight,
  separatorProps = {},
  itemProps = {},
  containerProps = {},
}) => {
  const handleItemClick = (item, index) => {
    if (item.onClick) {
      item.onClick();
    } else if (onItemClick) {
      onItemClick(item, index);
    }
  };

  const renderItem = (item, index) => {
    const isLast = index === items.length - 1;
    const isClickable = item.onClick || onItemClick;
    
    return (
      <React.Fragment key={index}>
        <Text
          fontSize="sm"
          fontWeight={isLast ? 400 : 500}
          color={isLast ? "granite" : "dark.500"}
          cursor={isClickable ? "pointer" : "default"}
          onClick={() => isClickable && handleItemClick(item, index)}
          _hover={isClickable ? { color: "purple.500" } : {}}
          data-testid={item.testId || `breadcrumb-item-${index}`}
          {...itemProps}
          {...item.textProps}
        >
          {item.title}
        </Text>
        {!isLast && (
          <Icon
            as={separator}
            boxSize={3}
            color="dark.500"
            {...separatorProps}
          />
        )}
      </React.Fragment>
    );
  };

  return (
    <HStack spacing={2} {...containerProps}>
      {items.map((item, index) => renderItem(item, index))}
    </HStack>
  );
};

export default Breadcrumb;
